import classNames from 'classnames';
import { ReactElement, useEffect, useState } from 'react';

import { Hours, Phone } from '~components/AllianceCallService/AllianceCallService';
import { useAppSelector } from '~hooks/useRedux';

import { recursivelyConvertStrings } from './recursionUtils';

const DynamicContentParagraph = ({
    children,
    className = '',
    ...rest
}: React.PropsWithChildren<{ className: string }>) => {
    const phoneNumber = useAppSelector((state) => state.global.phone.number);
    const hours = useAppSelector((state) => state.global.hours).replace(' <br/>', ', ');

    const [dynamicContent, setDynamicContent] = useState(children);

    useEffect(() => {
        const vars = {
            PHONE: '{{PHONE_NUMBER}}',
            HOURS: '{{HOURS}}',
        };

        const replaceAllVars = (node: string): string | SimpleChildElementModel => {
            if (node.includes(vars.PHONE)) {
                const firstOccurance = node.indexOf(vars.PHONE);
                const firstPart = node.slice(0, firstOccurance);
                const restOfTheString = node.slice(firstOccurance).replace(vars.PHONE, '');
                return (
                    <>
                        {firstPart}
                        <Phone />
                        {replaceAllVars(restOfTheString)}
                    </>
                );
            }
            if (node.includes(vars.HOURS)) {
                const firstOccurance = node.indexOf(vars.HOURS);
                const firstPart = node.slice(0, firstOccurance);
                const restOfTheString = node.slice(firstOccurance).replace(vars.HOURS, '');
                return (
                    <>
                        {firstPart}
                        <Hours isinline />
                        {replaceAllVars(restOfTheString)}
                    </>
                );
            }
            return node;
        };

        const newChildContent = recursivelyConvertStrings(
            dynamicContent as string | SimpleChildElementModel,
            replaceAllVars
        ) as ReactElement;

        setDynamicContent(newChildContent);
    }, [phoneNumber, hours]);

    return (
        <p className={classNames(className)} {...rest}>
            {dynamicContent || children}
        </p>
    );
};

export default DynamicContentParagraph;
